import React, { useState, useRef } from "react";
import {
  createUserWithEmailAndPassword,
  sendEmailVerification,
} from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { db, auth } from "../Configuration/firebase"; // Import Firestore instance
import { useNavigate } from "react-router-dom";
import { friendlyAuthError } from "../utils/authErrors";

function SignUp() {
  const [error, setError] = useState(null);
  const emailRef = useRef();
  const passwordRef = useRef();
  const firstNameRef = useRef();
  const lastNameRef = useRef();
  const navigate = useNavigate(); // Navigation hook

  const handleSignUp = async (e) => {
    e.preventDefault();

    const email = emailRef.current.value;
    const password = passwordRef.current.value;
    const firstName = firstNameRef.current.value;
    const lastName = lastNameRef.current.value;

    if (!email || !password || !firstName || !lastName) {
      setError("All fields are required.");
      return;
    }

    if (password.length < 6) {
      setError("Password should be at least 6 characters.");
      return;
    }

    try {
      // Create user with email and password
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password,
      );

      // Get the user info from Firebase Authentication
      const user = userCredential.user;

      // Store the additional user info (first name, last name) in Firestore
      await setDoc(doc(db, "users", user.uid), {
        firstName: firstName,
        lastName: lastName,
        email: email,
        categories: ["Home", "Work"],
      });

      try {
        const idToken = await user.getIdToken();
        const response = await fetch(
          "https://us-central1-one-address-53a06.cloudfunctions.net/sendVerificationEmail",
          {
            method: "POST",
            headers: { Authorization: `Bearer ${idToken}` },
          },
        );
        if (!response.ok) {
          throw new Error(`sendVerificationEmail returned ${response.status}`);
        }
      } catch (verificationEmailError) {
        // Custom branded email isn't set up yet (or failed) - fall back to
        // Firebase Auth's default template so the user still gets an email.
        console.error(
          "Custom verification email failed, falling back to default:",
          verificationEmailError,
        );
        await sendEmailVerification(user);
      }
      console.log("User signed up and data saved:", user);
      navigate("/login");
      // Optionally, redirect the user or show a success message
    } catch (error) {
      setError(friendlyAuthError(error));
      console.error("Error during sign-up:", error.message);
    }
  };

  const handleCancel = () => {
    navigate("/login"); // Navigate back to the main page
  };

  return (
    <div
      className="container"
      style={{
        width: "80%",
        maxWidth: "400px",
        margin: "auto",
        paddingTop: "calc(20px + env(safe-area-inset-top, 0px))",
      }}
    >
      <h2>Sign Up</h2>
      {error && <p style={{ color: "red" }}>{error}</p>}
      <form onSubmit={handleSignUp}>
        <input
          type="text"
          placeholder="First Name"
          ref={firstNameRef}
          style={{
            width: "90%",
            padding: "10px 15px",
            marginBottom: "10px",
            borderRadius: "20px",
            border: "1px solid var(--border-color, #ccc)",
            backgroundColor: "var(--input-bg, #fff)",
            color: "var(--text-primary, #000)",
          }}
        />
        <input
          type="text"
          placeholder="Last Name"
          ref={lastNameRef}
          style={{
            width: "90%",
            padding: "10px 15px",
            marginBottom: "10px",
            borderRadius: "20px",
            border: "1px solid var(--border-color, #ccc)",
            backgroundColor: "var(--input-bg, #fff)",
            color: "var(--text-primary, #000)",
          }}
        />
        <input
          type="email"
          placeholder="Email"
          ref={emailRef}
          style={{
            width: "90%",
            padding: "10px 15px",
            marginBottom: "10px",
            borderRadius: "20px",
            border: "1px solid var(--border-color, #ccc)",
            backgroundColor: "var(--input-bg, #fff)",
            color: "var(--text-primary, #000)",
          }}
        />
        <input
          type="password"
          placeholder="Password"
          ref={passwordRef}
          style={{
            width: "90%",
            padding: "10px 15px",
            marginBottom: "10px",
            borderRadius: "20px",
            border: "1px solid var(--border-color, #ccc)",
            backgroundColor: "var(--input-bg, #fff)",
            color: "var(--text-primary, #000)",
          }}
        />

        <button
          type="submit"
          style={{
            padding: "10px 15px",
            border: "none",
            cursor: "pointer",
            borderRadius: "5px",
            marginRight: "20px",
            backgroundColor: "#4CAF50",
            color: "white",
          }}
        >
          Sign Up
        </button>
        <button
          onClick={handleCancel}
          style={{
            backgroundColor: "gray",
            color: "white",
            padding: "10px 15px",
            border: "none",
            cursor: "pointer",
            borderRadius: "5px",
          }}
        >
          cancel
        </button>
      </form>
    </div>
  );
}

export default SignUp;
